import type {ItemConfig, ItemLiterals} from '@github-ui/filter-picker'
import {plural} from 'pluralize'

import type {DynamicSidePanelItem} from '../menu/dynamic-content/DynamicSidePanelItems'

export function createItemConfig(name: string, searchUrl: string): ItemConfig<DynamicSidePanelItem> {
  return {
    literals: createLiterals(name),
    getSearchUrl: (query: string) => {
      return `${searchUrl}?q=${query}`
    },
    onRenderItemName: item => item.value,
  }
}

function createLiterals(name: string): ItemLiterals {
  return {
    itemName: name.toLowerCase(),
    itemsName: plural(name.toLowerCase()),
    listTitle: `${plural(name.toLowerCase())} list`,
  }
}
